<template>
  <Dialog
    v-model:visible="isVisible"
    class="col-12 md:col-6"
    :modal="true"
    :closable="true"
    :dismissable-mask="true"
  >
    <template #header>
      <h3>{{ $t('dialog.appointmentdetails.title') }}</h3>
    </template>
    <div
      v-if="appointment"
      class="confirmation-content"
    >
      <p>
        {{ $t('entity.appointment.status') }} : <span class="font-bold">{{ $t(appointmentStatus.getDisplayKeyByStatus(appointment.status)) }}</span>
      </p>
      <p>
        {{ $t('entity.appointment.date') }} : <span class="font-bold">{{ getAppointmentDay(appointment.start) }}, {{
          $t('entity.planning.from')
        }} {{ getAppointmentStartTime(appointment.start) }} {{ $t('entity.planning.to') }} {{
          getAppointmentEndTime(appointment.end)
        }}</span>
      </p>
      <div v-if="appointment.office">
        <p>
          {{ $t('entity.office.site') }} : <span class="font-bold">{{ appointment.office.site.name }}</span>
        </p>
        <p>
          {{ $t('entity.site.address.field') }} :
          <span class="font-bold">
            {{ appointment.office.site.address.name }}, {{ appointment.office.site.address.postcode }} {{ appointment.office.site.address.city }}
          </span>
        </p>
        <p>{{ $t('entity.appointment.office') }} : <span class="font-bold">{{ appointment.office.name }}</span></p>
        <p>
          {{ $t('entity.user.user') }} : <span class="font-bold">{{ appointment.request.user.firstname }} {{ appointment.request.user.lastname }}</span>
        </p>
        <p>
          {{ $t('entity.user.company') }} : <span class="font-bold">{{ appointment.request.user.company }}</span>
        </p>
      </div>
      <div v-else>
        <p>
          {{ $t('entity.appointment.roamingTeam') }} : <span class="font-bold">{{ appointment.roamingTeam.name }}</span>
        </p>
        <p>
          {{ $t('entity.site.address.field') }} :
          <span class="font-bold">
            {{ appointment.wishedMeetingAddress.name }}, {{ appointment.wishedMeetingAddress.postcode }} {{ appointment.wishedMeetingAddress.city }}
          </span>
        </p>
        <p>
          {{ $t('specialrequestcreatePage.sitecontact') }} : <span class="font-bold">{{ appointment.specialRequestContact.firstName }} {{ appointment.specialRequestContact.lastName }}</span>
        </p>
        <p>
          {{ $t('entity.specialrequest.specialRequestContact.company') }} : <span class="font-bold">{{ appointment.specialRequestContact.company }}</span>
        </p>
      </div>
      <p>
        {{ $t('entity.user.stakeholderId') }} : <span class="font-bold">{{
          appointment.request.user.stakeholder.stakeholderId
        }}</span>
      </p>
    </div>

    <template #footer>
      <Button
        :label="$t('action.details')"
        icon="pi pi-eye"
        class="p-button-rounded p-button-outlined"
        @click="$router.push({name: 'appointmentDetail', params: {id: appointment.id}})"
      />
    </template>
  </Dialog>
</template>

<script>
import {convertDateStringToDayLocaleString, convertDateStringToTimeLocaleString} from "@/shared/utils/dateTimeUtils";
import moment from "moment";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import useAppointmentStatus from "@/composables/useAppointmentStatus";

export default {
  name: 'AppointmentDetailDialog',
  components: {Dialog, Button},
  props: {
    appointment: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
    }
  },
  emits: ['update:visible'],
  setup(){
    const appointmentStatus = useAppointmentStatus();
    return {
      appointmentStatus
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    getAppointmentDay(dateString) {
      return convertDateStringToDayLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentStartTime(dateString) {
      return convertDateStringToTimeLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentEndTime(dateString) {
      const end = moment(dateString, 'HH:mm:ss').toDate()
      return convertDateStringToTimeLocaleString(end, this.$i18n.locale)
    },
  }
}
</script>
